import { IS_PROD } from './env.config';

// const RAJ_CALENDLY = "https://calendly.com/logisticsnow/logisticsnow-connect"
const SALES_LORRI_AI_CALENDLY = 'https://calendly.com/lorri-sales/30min'
const SHARVIL_CALENDLY = 'https://calendly.com/sharvil-thelogisticsnow/30min';


export const CALENDLY_URL = IS_PROD ? SALES_LORRI_AI_CALENDLY : SHARVIL_CALENDLY;
export const SAVINGS_REPORT_CALENDLY_URL = CALENDLY_URL;
export const PRICING_RECOMMENDATION_CALENDLY_URL = CALENDLY_URL;
